import { clsx } from 'clsx'

interface SegmentedOption<T> {
  value: T
  label: string
}

interface SegmentedButtonProps<T> {
  options: SegmentedOption<T>[]
  value: T
  onChange: (value: T) => void
  className?: string
}

export function SegmentedButton<T>({ 
  options, 
  value, 
  onChange,
  className 
}: SegmentedButtonProps<T>) {
  return (
    <div className={clsx(
      "inline-flex rounded-full p-0.5 bg-gray-200 dark:bg-gray-700",
      className
    )}>
      {options.map((option, index) => (
        <button
          key={index}
          type="button"
          onClick={() => onChange(option.value)}
          className={clsx(
            "px-4 py-1.5 text-sm font-normal rounded-full transition-all duration-200 min-w-[80px]",
            value === option.value
              ? "bg-primary text-primary-foreground shadow-sm"
              : "text-gray-700 dark:text-gray-300 hover:text-gray-900 dark:hover:text-gray-100"
          )}
        >
          {option.label}
        </button>
      ))}
    </div>
  )
}